"use client";

import { useState, type ChangeEvent } from "react";
import { Header } from "@/components/quiz/explainers/header";
import { Button } from "@workspace/ui/components/button";
import { Input } from "@workspace/ui/components/input";

interface QuizUserDetailsProps {
  onSubmit: (name: string, email: string) => void;
}

const EMAIL_REGEX =
  /^(?!.*\s)[A-Za-z0-9]+(?:\.[A-Za-z0-9]+)*@[A-Za-z0-9]+(?:\.[A-Za-z0-9]+)+$/;

export function QuizUserDetails({ onSubmit }: QuizUserDetailsProps) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const isEmailValid = EMAIL_REGEX.test(email);
  const isButtonEnabled = name.trim() !== "" && isEmailValid;

  const handleNext = () => {
    if (!isButtonEnabled) return;
    onSubmit(name.trim(), email.trim());
  };

  return (
    <>
      <div
        className="flex flex-1 flex-col gap-6"
        data-testid="user-details-screen"
      >
        <Header title="Enter your details to get the sample hormone chart in your inbox!" />
        <div className="gap-3 flex flex-col">
          <Input
            className="h-[60px] py-0 rounded-[36px] px-4 hover:border-primary focus-visible:border-primary focus-visible:ring-0"
            placeholder="Name"
            value={name}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
            data-testid="user-details-name"
          />
          <Input
            className="h-[60px] py-0 rounded-[36px] px-4 hover:border-primary focus-visible:border-primary focus-visible:ring-0"
            placeholder="Email*"
            type="email"
            value={email}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
            data-testid="user-details-email"
          />
        </div>
        <p className="text-muted-foreground body-12 text-center">
          Inito ensures the confidentiality of your personal information. Your
          results will be emailed to you so you can access them easily.
        </p>
      </div>
      <div className="sticky bottom-0 flex flex-col gap-3 pb-6">
        <Button
          onClick={handleNext}
          disabled={!isButtonEnabled}
          variant="default"
          size="lg"
          className="w-full"
        >
          See my hormone chart
        </Button>
      </div>
    </>
  );
}
